import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

export const listMyOrders = createAsyncThunk(
    'orders/listMyOrders',
    async (_, { getState, rejectWithValue }) => {
        try {
            const {
                user: { userInfo },
            } = getState();

            if (!userInfo || !userInfo.token) {
                return rejectWithValue('Not authorized, please login');
            }

            const config = {
                headers: {
                    Authorization: `Bearer ${userInfo.token}`,
                },
            };

            const { data } = await axios.get('/api/orders/myorders', config);
            return data;
        } catch (error) {
            return rejectWithValue(
                error.response && error.response.data.message
                    ? error.response.data.message
                    : error.message
            );
        }
    }
);

const orderSlice = createSlice({
    name: 'orders',
    initialState: {
        orderListMy: { orders: [] },
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(listMyOrders.pending, (state) => {
                state.orderListMy = { loading: true };
            })
            .addCase(listMyOrders.fulfilled, (state, action) => {
                state.orderListMy = { loading: false, orders: action.payload };
            })
            .addCase(listMyOrders.rejected, (state, action) => {
                state.orderListMy = { loading: false, error: action.payload };
            });
    },
});

export default orderSlice.reducer;
